// extracted by mini-css-extract-plugin
module.exports = {"WEIGHT":"400","PATH":"/app/themes/strazzanti/dist/font/f37ginger-regular.7cc1748a8b0d7a7b1d1a.ttf","NAME":"F37 Ginger","STYLE":"normal"};